export default __webpack_public_path__ + "static/media/Logo-Libo-removebg-preview.d32216e7.png";